export default __webpack_public_path__ + "static/Ziegler_Logo_RGB_Claim_schwarz-f8562f98f5c5dfa98b57829483ca5293.svg";